// extracted by mini-css-extract-plugin
export default {"jslContainer":"ys_yt","jslBall":"ys_yu"};